import seoMetadata from './seo-metadata.json';

/**
 * 全63ルートのSEOメタデータ（生成+検証済み, 2026-06-13）。
 * route をキーに title/description/keywords/canonical/jsonLdType/h1/noindex を引く。
 * 各ページは getSeo(path) で取得し <PageHead {...} /> に渡す。
 * title は「{ページ固有}｜日本執事アカデミー」のフル文字列（PageHead には rawTitle で渡す）。
 */
export interface SeoEntry {
  route: string;
  noindex: boolean;
  title: string;
  description: string;
  keywords: string[];
  canonical: string;
  jsonLdType: string;
  h1: string;
  // optional English fields (P2-T3 翻訳は別タスク。未定義時は ja にフォールバック)
  title_en?: string;
  description_en?: string;
  keywords_en?: string[];
  h1_en?: string;
}

/** lang='en' 時: en フィールドがあれば優先、なければ ja フォールバック */
export function getSeoTitle(entry: SeoEntry, lang: 'ja' | 'en'): string {
  return (lang === 'en' && entry.title_en) ? entry.title_en : entry.title;
}
export function getSeoDescription(entry: SeoEntry, lang: 'ja' | 'en'): string {
  return (lang === 'en' && entry.description_en) ? entry.description_en : entry.description;
}
export function getSeoKeywords(entry: SeoEntry, lang: 'ja' | 'en'): string[] {
  return (lang === 'en' && entry.keywords_en) ? entry.keywords_en : entry.keywords;
}
export function getSeoH1(entry: SeoEntry, lang: 'ja' | 'en'): string {
  return (lang === 'en' && entry.h1_en) ? entry.h1_en : entry.h1;
}

const entries = seoMetadata as SeoEntry[];

const byRoute: Record<string, SeoEntry> = entries.reduce(
  (acc, e) => {
    acc[e.route] = e;
    return acc;
  },
  {} as Record<string, SeoEntry>,
);

/** route 文字列（例 "/courses/essential"）から SEO を取得。未登録なら undefined。 */
export function getSeo(route: string): SeoEntry | undefined {
  return byRoute[route];
}

export { byRoute as seoByRoute };
export default entries;
